import { ReactElement } from "react";
import { IHostSystemInformation } from "./types";
import GaugeChartV2 from "../../../components/charts/gaugeChartV2";
import { IGaugeConfig } from "../../../components/charts/types";
import { formatBytes } from "./utils";

interface IProps {
  status: IHostSystemInformation;
}

const SystemComponent = ({ status }: IProps): ReactElement => {
  const memGaugeConfig: IGaugeConfig = {
    width: 150,
    height: 150,
    minimum: 0,
    maximum: status.memory.available,
    start: 270,
    length: 180,
    color: undefined,
    segments: [
      { start: 0, end: status.memory.available * .5, color: "green" },
      { start: status.memory.available * .5, end: status.memory.available, color: "orange" }
    ],
    format: n => formatBytes(n, 1)
  };

  return (
    <div className="display-flex-column flex-grow-0" >
      <strong>System</strong>

      <div className="display-flex-row gap-2 mr-1 ml-1" style={{ height: 120 }}>
        <div className="indicator" style={{ width: 250, background: "rgba(255, 255, 255, .1)", height: 100 }}>
          <div className="display-flex-row">
            <div className="justify-self-start flex-grow-1">Memory</div>
            <div>{formatBytes(status.memory.used)}</div>
          </div>
          <GaugeChartV2 gaugeConfig={memGaugeConfig} value={status.memory.used}/>
        </div>

        <div className="display-grid justify-items-center align-items-center indicator"
          style={{
            width: 200,
            height: 100,
            gridTemplateColumns: "1fr 1fr 1fr",
            gridTemplateRows: "auto 1fr auto auto",
            justifyItems: "stretch",
            alignItems: "stretch"
          }}>
          <div style={{ gridRow: 1, gridColumn: "1/4" }}>
            <div className="justify-self-start flex-grow-1">CPU Average</div>
          </div>


          <h2 className="text-center" style={{ gridRow: 2, gridColumn: "1/4" }}>
            {status.currentLoad.avgLoad.toFixed(2)}
          </h2>

          <div style={{ gridRow: 3, gridColumn: 1 }} className="display-flex-column justify-items-center">
            <h3 className="text-center">{status.currentLoad.currentLoadSystem.toFixed(2)}</h3>
            <small className="text-center">System</small>
          </div>

          <div style={{ gridRow: 3, gridColumn: 2 }} className="display-flex-column justify-items-center">
            <h3 className="text-center">{status.currentLoad.currentLoadUser.toFixed(2)}</h3>
            <small className="text-center">User</small>
          </div>

          <div style={{ gridRow: 3, gridColumn: 3 }} className="display-flex-column justify-items-center">
            <h3 className="text-center" style={{ color: "green" }}>{status.currentLoad.currentLoadIdle.toFixed(2)}</h3>
            <small className="text-center">Idle</small>
          </div>

        </div>
      </div>
    </div>
  );
};

export default SystemComponent;